import React from "react";
import "../Styles/TestimonialCard.css";
import StarRating from "../components/StarRating";

const TestimonialCard = ({ name, image, description }) => {
  return (
    <div className="testimonial-card">
      <div className="testimonial-header">
        <img src={image} alt={name} className="profile-img" />
        <div>
          <h3 className="name">{name}</h3>
          <StarRating />
        </div>
      </div>
      <p className="description">{description}</p>
    </div>
  );
};

export default TestimonialCard;
